import { FC, memo } from "react"
import { GameCard } from "./GameCard"
import { ICardProps } from "./types"

const CardComponent: FC<ICardProps> = (props) => {
  return <GameCard {...props} />
}

export const Card = memo(CardComponent)
